/**
 * Hook for handling block positioning (overlay support)
 * Consolidates positioning logic into a reusable hook
 */
export const useBlockPositioning = (blockSettings) => {
    const positionType = blockSettings.position_type || 'relative';
    const zIndex = blockSettings.z_index || 10;
    
    // Calculate position properties for absolute positioning
    const getPositionProps = () => {
        if (positionType !== 'absolute') {
            return { isOverlay: false };
        }
        
        const positionTop = blockSettings.position_top;
        const positionLeft = blockSettings.position_left;
        const positionRight = blockSettings.position_right;
        const positionBottom = blockSettings.position_bottom;
        
        const transform = [];
        if (positionLeft !== undefined && positionRight === undefined) {
            transform.push('translateX(-50%)');
        }
        if (positionTop !== undefined && positionBottom === undefined) {
            transform.push('translateY(-50%)');
        }
        
        return {
            isOverlay: true,
            zIndex,
            position: 'absolute',
            ...(positionTop !== undefined && { top: `${positionTop}%` }),
            ...(positionLeft !== undefined && { left: `${positionLeft}%` }),
            ...(positionRight !== undefined && { right: `${positionRight}%` }),
            ...(positionBottom !== undefined && { bottom: `${positionBottom}%` }),
            ...(transform.length > 0 && { transform: transform.join(' ') })
        };
    };
    
    return {
        positionType,
        isAbsolute: positionType === 'absolute',
        positionProps: getPositionProps()
    };
};
